import type { ProjectMembersQueryParams } from '../api/projectMembers.service';

export const PROJECT_KEYS = {
  all: ['projects'] as const,
  byOrg: (orgId: string) => ['projects', orgId] as const,
  list: (orgId: string) => ['projects', orgId, 'list'] as const,
  listInfinite: (orgId: string) => ['projects', orgId, 'list', 'infinite'] as const,
  myProjects: (orgId: string) => ['projects', orgId, 'myProjects'] as const,
  myProjectsInfinite: (orgId: string) => ['projects', orgId, 'myProjects', 'infinite'] as const,
  detail: (orgId: string, projectId: string) => ['projects', orgId, projectId] as const,
  tasks: (orgId: string, projectId: string) => ['projects', orgId, projectId, 'tasks'] as const,
  members: (orgId: string, projectId: string) => ['projects', orgId, projectId, 'members'] as const,
  membersSearch: (orgId: string, projectId: string, params: ProjectMembersQueryParams) =>
    ['projects', orgId, projectId, 'members', 'search', params] as const,
  summary: (orgId: string, projectId: string) => ['projects', orgId, projectId, 'summary'] as const,
};
